import { ValueContainer } from "components/shared/select";
import React from "react";
import BaseCarTypeFilter from "./baseCarType";

const MultipleCarTypeFilter = (props) => {
    const setValue = ({ name, value }) => {
        props.setFilter({ name, value: value && value.length > 0 ? { in: value } : null });
    };
    const selectProps = {
        inputProps: { name: "multipleCarTypeId" },
        value: props.values.multipleCarTypeId ? props.values.multipleCarTypeId.in : null,
        components: { ValueContainer },
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        isMulti: true,
        setValue: setValue,
    };
    return <BaseCarTypeFilter {...props} selectProps={selectProps} />;
};

export default MultipleCarTypeFilter;
